module.exports = __webpack_public_path__ + "static/images/details-1.054fa67.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/product/zfb/details-1.png
// module id = fmIt
// module chunks = 0